import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
var useIsSubsequentRender = function useIsSubsequentRender() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubsequentRender = _useState2[0],
    setIsSubsequentRender = _useState2[1];
  useEffect(function () {
    setIsSubsequentRender(true);
  }, []);
  return isSubsequentRender;
};
export default useIsSubsequentRender;